<template>
  <div>
    <transition name="slide-from-left">
      <div
        v-show="isVisible"
        class="fixed left-0 inset-y-0 w-full max-w-lg bg-white z-80"
      >
        <div class="flex flex-col h-full">
          <div class="px-5 py-5 sm:py-6 border-b bg-white">
            <div class="grid grid-cols-6">
              <button class="col-span-1 link" @click="$emit('closed')">
                <div class="w-5 h-5">
                  <IconCross />
                  <span class="sr-only">Close Oil Calculator</span>
                </div>
              </button>
              <h3 class="col-span-4 text-md sm:text-lg text-center">
                Oil Calculator
              </h3>
            </div>
          </div>
          <form
            novalidate
            class="flex-1 h-full overflow-y-auto scrolling-touch"
          >
            <div class="h-full flex flex-col">
              <div class="flex-1 px-2 sm:px-6 py-6 space-y-6">
                <fieldset v-if="!(onlyExterior || onlyInterior)">
                  <legend class="sr-only">Job Type</legend>
                  <div class="grid grid-cols-2 gap-3 sm:gap-6">
                    <div class="col-span-2 sm:col-span-1">
                      <Toggle
                        id="coating-is-interior"
                        v-model="isInterior"
                        :labels="['Interior', 'Exterior']"
                      />
                    </div>
                  </div>
                </fieldset>
                <InteriorAreaAccordion
                  v-show="isInterior"
                  :options="interiorUsageOptions"
                />
                <ExteriorAreaAccordion
                  v-show="!isInterior"
                  :options="exteriorUsageOptions"
                />
              </div>
              <section>
                <div class="bg-grey py-7 px-2 sm:px-6">
                  <InteriorAreaResultsPanel
                    v-if="isInterior"
                    :coating="coating"
                    class="bg-white px-3 py-4"
                  />
                  <ExteriorAreaResultsPanel
                    v-else
                    :coating="coating"
                    class="bg-white px-3 py-4"
                  />
                </div>
                <div>
                  <div
                    class="flex flex-wrap justify-between border-t py-5 px-2 sm:px-6 bg-paint"
                  >
                    <button
                      class="link underline text-left text-theme"
                      type="button"
                      @click="isSendFormOpen = !isSendFormOpen"
                    >
                      Email me this info
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </form>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <Modal v-show="isSendFormOpen" @close="isSendFormOpen = false">
        <EmailForm
          :coating="coating"
          :is-interior="isInterior"
          @close="handleEmailFormSubmit()"
        />
      </Modal>
    </transition>
  </div>
</template>

<script>
import ExteriorAreaAccordion from "./Accordions/ExteriorCoatingAreaAccordion.vue";
import InteriorAreaAccordion from "./Accordions/InteriorCoatingAreaAccordion.vue";
import ExteriorAreaResultsPanel from "./ResultsPanel/ExteriorCoatingResultsPanel.vue";
import InteriorAreaResultsPanel from "./ResultsPanel/InteriorCoatingResultsPanel.vue";
import EmailForm from "./CoatingCalculatorEmailForm.vue";
import Modal from "../Modal/Modal.vue";
import IconCross from "../../../templates/_includes/svg/icon-cross.svg";
import Toggle from "./ui/Toggle.vue";

export default {
  name: "CoatingCalculator",

  components: {
    ExteriorAreaAccordion,
    InteriorAreaAccordion,
    ExteriorAreaResultsPanel,
    InteriorAreaResultsPanel,
    EmailForm,
    Modal,
    IconCross,
    Toggle,
  },

  props: {
    coating: {
      type: Object,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isInterior:
        this.coating.interiorUsageOptions.filter((option) => option.selected)
          .length > 0,
      isSendFormOpen: false,
    };
  },

  computed: {
    exteriorUsageOptions() {
      return this.coating.exteriorUsageOptions.filter(
        (option) => option.selected
      );
    },
    interiorUsageOptions() {
      return this.coating.interiorUsageOptions.filter(
        (option) => option.selected
      );
    },
    onlyExterior() {
      return this.interiorUsageOptions.length === 0;
    },
    onlyInterior() {
      return this.exteriorUsageOptions.length === 0;
    },
  },

  methods: {
    handleEmailFormSubmit() {
      this.isSendFormOpen = false;
      this.$store.commit("closeCoatingCalculator");
    },
  },
};
</script>
